module.exports = __webpack_public_path__ + "img/img-f1e290e4.66874f9e.png";